const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/insights/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { VarianceGroupByValues } from '@/lib/api/types/insights/variance';
import { DATE_FILTER_REGEX, PICKLIST_FILTER_REGEX } from '@/lib/utils/insights/compact-filters/filterOperators';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';

/**
 * Validates compact picklist filter format: operator_value1-value2-...
 * Examples: in_50, in_30-34-35, empty, notempty
 */
const compactPicklistFilterSchema = z.string().regex(PICKLIST_FILTER_REGEX, 'Invalid picklist filter format. Expected: operator_value1-value2 (e.g., in_50 or in_30-34)').optional();

/**
 * Validates compact date filter format: operator_date1_date2
 * Examples: is_2025-11-12, after_2025-11-04, in_2024-01-01_2024-12-31, empty, notempty
 * Note: 'is' operator accepts single date in URL; end-of-day timestamp is computed by RSQL layer
 */
const compactDateFilterSchema = z.string().regex(DATE_FILTER_REGEX, 'Invalid date filter format. Expected: operator_YYYY-MM-DD (e.g., is_2025-11-12, after_2025-11-04, or in_2024-01-01_2024-12-31)').optional();
export const insightsSearchSchema = z.object({
  containerId: z.preprocess(v => v === '' || v === undefined ? undefined : Number(v), z.number().int().positive()).optional(),
  planId: compactPicklistFilterSchema,
  teamId: compactPicklistFilterSchema,
  statusId: compactPicklistFilterSchema,
  itemTypeId: compactPicklistFilterSchema,
  integrationId: compactPicklistFilterSchema,
  expectedStartDateTime: compactDateFilterSchema,
  expectedFinishDateTime: compactDateFilterSchema,
  latestFinishDateTime: compactDateFilterSchema,
  orderBy: z.enum(['priority', 'expectedStartDateTime', 'expectedFinishDateTime', 'latestFinishDateTime']).optional(),
  orderDir: z.enum(['asc', 'desc']).optional(),
  groupBy: z.enum(VarianceGroupByValues).optional()
});
export const insightsDeliverablesSearchSchema = insightsSearchSchema.and(itemPanelSearchSchema);
export const Route = createFileRoute('/(app)/org/$org/insights')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(insightsDeliverablesSearchSchema)
});